import { combineReducers } from "redux";
import raise from "../features/admin/raisefund/raise/Slice";

const raisefund = combineReducers({
  raise: raise,
});

export default raisefund;
